// extracted by mini-css-extract-plugin
export default {"banner":"IFDgE","inner":"NI2vt","title":"hxuwa"};